/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Container, SlideStayInformed } from './styles';
import Botox from './Botox';
import ClearAligners from './ClearAligners';
import Implants from './Implants';
import Doctors from './Doctors';

import devsigner from '~/assets/tv/devsigner-logo.svg';
import bgNews from '~/assets/tv/bg-news.png';
import qrCodeWhatsapp from '~/assets/tv/qrcode-whatsapp.svg';
import JowlLipo from './JowlLipo';
import StopHidingSmile from './StopHidingSmile';
import ConfidenceToSmile from './ConfidenceToSmile';
import MakeYourImplant from './MakeYourImplant';
import SolutionWithAuthority from './SolutionWithAuthority';
import EasyPayment from './EasyPayment';
import ElectricToothbrush from './ElectricToothbrush';
import HowToWinElectricToothbrush from './HowToWinElectricToothbrush';
import DoubleChinLiposuction from './DoubleChinLiposuction';
import ChangeYourSmile1 from './ChangeYourSmile/images/img1';
import ChangeYourSmile2 from './ChangeYourSmile/videos/tv2';
import ChangeYourSmile3 from './ChangeYourSmile/videos/tv3';
import ChangeYourSmile4 from './ChangeYourSmile/videos/tv4';
import ChangeYourSmile5 from './ChangeYourSmile/images/img5';
import ChangeYourSmile6 from './ChangeYourSmile/images/img6';
import ChangeYourSmile7 from './ChangeYourSmile/images/img7';
import ChangeYourSmile8 from './ChangeYourSmile/images/img8';

interface ISlide {
  slide: string;
  slideTime: number;
  beforeTime?: number;
  afterTime?: number;
  bgSlide?: string;
}

const Tv: React.FC = () => {
  // const valentinesVideoRef = useRef<HTMLVideoElement>(null);
  const [slideSelected, setSlideSelected] = useState({} as ISlide);
  const [, setShowBefore] = useState('SlideCoiKidsIntro');
  const [animSlideSelected, setAnimSlideSelected] = useState('');
  const [, setEndAnimSlideSelected] = useState('');

  const slides = useMemo<ISlide[]>(
    () => [
      // { slide: 'ClearAligners', slideTime: 65000 },
      { slide: 'Doctors', slideTime: 40000 },
      { slide: 'ChangeYourSmile1', slideTime: 7500 },
      { slide: 'ChangeYourSmile2', slideTime: 13000 },
      { slide: 'ChangeYourSmile3', slideTime: 66000 },
      { slide: 'ChangeYourSmile4', slideTime: 105000 },
      { slide: 'ChangeYourSmile5', slideTime: 7500 },
      { slide: 'ChangeYourSmile6', slideTime: 7500 },
      { slide: 'ChangeYourSmile7', slideTime: 7500 },
      // { slide: 'ChangeYourSmile8', slideTime: 7500 },
      // { slide: 'Botox', slideTime: 15000 },
      // { slide: 'Implants', slideTime: 15000 },
      // { slide: 'JowlLipo', slideTime: 7500 },
      // { slide: 'SlideStayInformed', slideTime: 15000 },
      // { slide: 'StopHidingSmile', slideTime: 7500 },
      // { slide: 'ConfidenceToSmile', slideTime: 7500 },
      // { slide: 'MakeYourImplant', slideTime: 7500 },
      // { slide: 'SolutionWithAuthority', slideTime: 113000 },
      // { slide: 'DoubleChinLiposuction', slideTime: 37500 },
      // { slide: 'EasyPayment', slideTime: 7500 },
      // { slide: 'ElectricToothbrush', slideTime: 7500 },
      // { slide: 'HowToWinElectricToothbrush', slideTime: 23000 },
    ],
    []
  );

  const changeSlide = useCallback(
    (index) => {
      const { slide, slideTime } = slides[index];

      if (slides[index + 1] && slides[index + 1].beforeTime) {
        const nextSlide = slides[index + 1];
        if (nextSlide.beforeTime)
          setTimeout(() => {
            setShowBefore(nextSlide.slide);
            setAnimSlideSelected(nextSlide.slide);
          }, slideTime - nextSlide.beforeTime);
      }

      if (slides[index - 1] && slides[index - 1].afterTime) {
        const prevSlide = slides[index - 1];
        if (prevSlide.afterTime) {
          setEndAnimSlideSelected(prevSlide.slide);
          setSlideSelected(slides[index]);
          setTimeout(() => {
            setShowBefore('');
            setEndAnimSlideSelected('');
          }, prevSlide.afterTime);
        }
      } else {
        setSlideSelected(slides[index]);
      }

      setTimeout(() => {
        setAnimSlideSelected(slide);
        if (index + 1 < slides.length) {
          setTimeout(() => {
            changeSlide(index + 1);
          }, slideTime);
        } else {
          setTimeout(() => {
            changeSlide(0);
          }, slideTime);
        }
      }, 100);
    },
    [slides]
  );

  // useEffect(() => {
  //   if (slideSelected.slide === 'ValentinesVideo') {
  //     valentinesVideoRef.current?.play();
  //   }
  // }, [slideSelected.slide]);

  // 🔹 Função de limpeza de cache + reset dos slides
  const clearCacheAndResetSlides = useCallback(() => {
    // Limpeza de cache local
    localStorage.clear();
    sessionStorage.clear();
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });

    // Reset de estados
    setSlideSelected({} as ISlide);
    setAnimSlideSelected('');
    setEndAnimSlideSelected('');

    // Reinicia slides do começo
    changeSlide(0);
  }, [changeSlide]);

  // 🔹 Agendamento para todos os dias às 7h
  useEffect(() => {
    const now = new Date();
    const next7h = new Date();

    next7h.setHours(7, 0, 0, 0);
    if (now > next7h) {
      // já passou das 7h de hoje → agenda para amanhã
      next7h.setDate(next7h.getDate() + 1);
    }

    const timeout = next7h.getTime() - now.getTime();

    const timer = setTimeout(() => {
      clearCacheAndResetSlides();

      // repetir a cada 24h
      setInterval(() => {
        clearCacheAndResetSlides();
      }, 24 * 60 * 60 * 1000);
    }, timeout);

    return () => clearTimeout(timer);
  }, [clearCacheAndResetSlides]);

  useEffect(() => {
    changeSlide(0);
  }, [changeSlide]);

  return (
    <Container className="position-relative">
      {/* <JowlLipo
        show={slideSelected.slide === 'JowlLipo'}
        startAnim={animSlideSelected === 'JowlLipo'}
      /> */}
      {/* <DoubleChinLiposuction
        show={slideSelected.slide === 'DoubleChinLiposuction'}
        startAnim={animSlideSelected === 'DoubleChinLiposuction'}
      /> */}
      <ClearAligners
        show={slideSelected.slide === 'ClearAligners'}
        startAnim={animSlideSelected === 'ClearAligners'}
      />
      {/* <Implants
        show={slideSelected.slide === 'Implants'}
        startAnim={animSlideSelected === 'Implants'}
      /> */}
      <Doctors
        show={slideSelected.slide === 'Doctors'}
        startAnim={animSlideSelected === 'Doctors'}
      />

      <ChangeYourSmile1
        show={slideSelected.slide === 'ChangeYourSmile1'}
        startAnim={animSlideSelected === 'ChangeYourSmile1'}
      />
      <ChangeYourSmile2
        show={slideSelected.slide === 'ChangeYourSmile2'}
        startAnim={animSlideSelected === 'ChangeYourSmile2'}
      />
      <ChangeYourSmile3
        show={slideSelected.slide === 'ChangeYourSmile3'}
        startAnim={animSlideSelected === 'ChangeYourSmile3'}
      />
      <ChangeYourSmile4
        show={slideSelected.slide === 'ChangeYourSmile4'}
        startAnim={animSlideSelected === 'ChangeYourSmile4'}
      />
      <ChangeYourSmile5
        show={slideSelected.slide === 'ChangeYourSmile5'}
        startAnim={animSlideSelected === 'ChangeYourSmile5'}
      />
      <ChangeYourSmile6
        show={slideSelected.slide === 'ChangeYourSmile6'}
        startAnim={animSlideSelected === 'ChangeYourSmile6'}
      />
      <ChangeYourSmile7
        show={slideSelected.slide === 'ChangeYourSmile7'}
        startAnim={animSlideSelected === 'ChangeYourSmile7'}
      />
      <ChangeYourSmile8
        show={slideSelected.slide === 'ChangeYourSmile8'}
        startAnim={animSlideSelected === 'ChangeYourSmile8'}
      />
      {/* <SlideStayInformed
        show={slideSelected.slide === 'SlideStayInformed'}
        startAnim={animSlideSelected === 'SlideStayInformed'}
        endAnim={endAnimSlideSelected === 'SlideStayInformed'}
        bgImage={bgNews}
      >
        <div className="slide-container">
          <p className="title">
            Quer acompanhar todas as novidades e promoções?
          </p>
          <img
            src={qrCodeWhatsapp}
            alt="qrCodeWhatsapp"
            className="qr-whatsapp"
          />
          <p className="content">
            <b>Salve nosso contato</b> e fique por dentro de todas as novidades
          </p>
          <div className="d-flex align-items-center devsigner">
            <p className="mb-0">Desenvolvido por:</p>
            <img src={devsigner} alt="devsigner" />
          </div>
        </div>
      </SlideStayInformed> */}
      {/* <StopHidingSmile
        show={slideSelected.slide === 'StopHidingSmile'}
        startAnim={animSlideSelected === 'StopHidingSmile'}
      /> */}
      {/* <ConfidenceToSmile
        show={slideSelected.slide === 'ConfidenceToSmile'}
        startAnim={animSlideSelected === 'ConfidenceToSmile'}
      /> */}
      {/* <MakeYourImplant
        show={slideSelected.slide === 'MakeYourImplant'}
        startAnim={animSlideSelected === 'MakeYourImplant'}
      /> */}
      {/* <SolutionWithAuthority
        show={slideSelected.slide === 'SolutionWithAuthority'}
        startAnim={animSlideSelected === 'SolutionWithAuthority'}
      /> */}
      {/* <EasyPayment
        show={slideSelected.slide === 'EasyPayment'}
        startAnim={animSlideSelected === 'EasyPayment'}
      /> */}
      {/* <ElectricToothbrush
        show={slideSelected.slide === 'ElectricToothbrush'}
        startAnim={animSlideSelected === 'ElectricToothbrush'}
      /> */}
      {/* <HowToWinElectricToothbrush
        show={slideSelected.slide === 'HowToWinElectricToothbrush'}
        startAnim={animSlideSelected === 'HowToWinElectricToothbrush'}
      /> */}
    </Container>
  );
};

export default Tv;
